// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-rows: 1fr 10fr;
  background-color: seagreen;
}

nav {
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
}

img {
  width: 3rem;
  height: 3rem;
}

button {
  border: none;
  color: white;
  cursor: pointer;
  padding: .5rem 2rem;
  border-radius: 30px;
  background-color: white;
}

.logo {
  gap: 1rem;
  display: flex;
  align-items: center;
}

.logo h2 {
  color: white;
  width: max-content;
}

.search {
  flex: 1;
  gap: 1rem;
  display: flex;
  max-width: 25rem;
}

.search #searchBar {
  flex: 1;
  min-width: 0;
  border: none;
  font-size: 1.5rem;
  padding: 0 1rem;
  max-width: 25rem;
  border-radius: 30px;
  background-color: white;
}

.search #searchBtn {
  padding: 1rem 1rem;
}

.search #searchBtn:hover {
  background-color: rgb(230, 230, 230);
}

.blank {
  width: 100%;
  display: flex;
  margin-top: 1rem;
  margin: 1px auto;
  align-items: start;
  justify-content: center;
}

.container {
  display: flex;
  color: white;
  font-size: 2rem;
  text-align: center;
  padding: 1rem 2rem;
  border-radius: 20px;
  align-items: center;
  flex-direction: column;
  background-color: rgb(20, 100, 50);
}

#unitBtn {
  margin: 1rem;
  font-size: 2rem;
  background-color: seagreen;
}

#unitBtn:hover {
  background-color: rgb(50, 170, 110);
}

.weather {
  gap: 1rem;
  display: flex;
  font-size: 5rem;
  align-items: center;
  justify-content: center;
}

.icon {
  width: 10rem;
  height: 10rem;
}

.details {
  display: flex;
  align-items: start;
  flex-direction: column;
}

.detail {
  display: flex;
  align-items: center;
}

@media (max-width: 700px) {

  .container,
  .search {
    width: 95%;
  }

  .logo h2 {
    display: none;
  }

  .search #searchBar {
    width: 1rem;
  }

  .place {
    font-size: 2.2rem;
    font-weight: bold;
  }

  .weather {
    gap: unset;
    font-size: 5rem;
  }

  .details {
    font-size: 1.8rem;
  }

}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;AAEF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  display: grid;\n  height: 100vh;\n  overflow: hidden;\n  grid-template-rows: 1fr 10fr;\n  background-color: seagreen;\n}\n\nnav {\n  gap: 1rem;\n  width: 100%;\n  padding: 1rem;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: space-between;\n}\n\nimg {\n  width: 3rem;\n  height: 3rem;\n}\n\nbutton {\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: .5rem 2rem;\n  border-radius: 30px;\n  background-color: white;\n}\n\n.logo {\n  gap: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.logo h2 {\n  color: white;\n  width: max-content;\n}\n\n.search {\n  flex: 1;\n  gap: 1rem;\n  display: flex;\n  max-width: 25rem;\n}\n\n.search #searchBar {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  font-size: 1.5rem;\n  padding: 0 1rem;\n  max-width: 25rem;\n  border-radius: 30px;\n  background-color: white;\n}\n\n.search #searchBtn {\n  padding: 1rem 1rem;\n}\n\n.search #searchBtn:hover {\n  background-color: rgb(230, 230, 230);\n}\n\n.blank {\n  width: 100%;\n  display: flex;\n  margin-top: 1rem;\n  margin: 1px auto;\n  align-items: start;\n  justify-content: center;\n}\n\n.container {\n  display: flex;\n  color: white;\n  font-size: 2rem;\n  text-align: center;\n  padding: 1rem 2rem;\n  border-radius: 20px;\n  align-items: center;\n  flex-direction: column;\n  background-color: rgb(20, 100, 50);\n}\n\n#unitBtn {\n  margin: 1rem;\n  font-size: 2rem;\n  background-color: seagreen;\n}\n\n#unitBtn:hover {\n  background-color: rgb(50, 170, 110);\n}\n\n.weather {\n  gap: 1rem;\n  display: flex;\n  font-size: 5rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  width: 10rem;\n  height: 10rem;\n}\n\n.details {\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n}\n\n.detail {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 700px) {\n\n  .container,\n  .search {\n    width: 95%;\n  }\n\n  .logo h2 {\n    display: none;\n  }\n\n  .search #searchBar {\n    width: 1rem;\n  }\n\n  .place {\n    font-size: 2.2rem;\n    font-weight: bold;\n  }\n\n  .weather {\n    gap: unset;\n    font-size: 5rem;\n  }\n\n  .details {\n    font-size: 1.8rem;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
